import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
import CarouselVideo from "./CarouselVideo";

const useStyles = makeStyles(styles);

const FirstSection = () => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.section}>
        {/* <FirstCarousel /> */}
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>
              How{`'`}s DRISHTI Empowering Vision?
            </h2>
            {/* <CarouselVideo /> */}
            <h5 className={classes.description} style={{ fontSize: "1.5rem", lineHeight: "2rem" }}>
              Our objective is to enable visually impaired people and
              non-attentive pedestrians to navigate through obstacles by
              non-intuitive method of muscle stimulation of sartorial muscles.
              Smarter real time decisions are made using Computer Vision
              Technique and Distance sensors. User can also navigate from one
              point to other using Google Navigation assistants.
            </h5>
          </GridItem>
        </GridContainer>
      </div>
    </>
  );
};

export default FirstSection;
